import { defineComponent as _defineComponent } from 'vue'
import { useVModel } from '@vueuse/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'SwitcherInput',
  props: {
    value: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({ (e: 'input', value: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean };




const isActive = useVModel(props, 'value', emit, { eventName: 'input' });

function handleToggle() {
    isActive.value = !isActive.value;
}

return { __sfc: true,props, emit, isActive, handleToggle }
}

})